import React from 'react'

export default function Dashboard() {
  return (
    <div className="min-h-screen container mx-auto bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white font-sans relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-cyan-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-purple-500 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-blue-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 p-4 sm:p-6 lg:p-8">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-cyan-400 via-blue-500 to-purple-600 bg-clip-text text-transparent mb-4">
          Fixet Dashboard
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 max-w-2xl mx-auto px-4">
            Your ultimate gateway to seamless urban services in the city
          </p>
        </div>

        {/* Hero Section */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6">
            Complete Urban Services at Your Fingertips
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-8">
            From daily essentials to emergency repairs - everything you need in the city, delivered fast and reliable.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-cyan-500/50">
              Book a Service
            </button>
            <button className="bg-white/10 hover:bg-white/20 px-8 py-4 rounded-2xl font-bold text-lg transition-all duration-300 border border-white/20">
              Become a Provider
            </button>
          </div>
        </div>

        {/* Service Categories */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 sm:mb-16">
          <div className="group backdrop-blur-lg bg-white/10 rounded-2xl p-4 sm:p-6 text-center border border-white/20 shadow-2xl hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">🏠</div>
            <h3 className="text-cyan-400 font-bold text-base sm:text-lg mb-2">Home Services</h3>
            <p className="text-gray-300 text-xs sm:text-sm">Cleaning, repairs, maintenance</p>
          </div>
          <div className="group backdrop-blur-lg bg-white/10 rounded-2xl p-4 sm:p-6 text-center border border-white/20 shadow-2xl hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">🛠️</div>
            <h3 className="text-green-400 font-bold text-base sm:text-lg mb-2">Repairs</h3>
            <p className="text-gray-300 text-xs sm:text-sm">AC, plumbing, electrical</p>
          </div>
          <div className="group backdrop-blur-lg bg-white/10 rounded-2xl p-4 sm:p-6 text-center border border-white/20 shadow-2xl hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">🚗</div>
            <h3 className="text-blue-400 font-bold text-base sm:text-lg mb-2">Transportation</h3>
            <p className="text-gray-300 text-xs sm:text-sm">Rides, deliveries, moving</p>
          </div>
          <div className="group backdrop-blur-lg bg-white/10 rounded-2xl p-4 sm:p-6 text-center border border-white/20 shadow-2xl hover:bg-white/15 transition-all duration-300 hover:scale-105">
            <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">🛍️</div>
            <h3 className="text-purple-400 font-bold text-base sm:text-lg mb-2">Daily Needs</h3>
            <p className="text-gray-300 text-xs sm:text-sm">Groceries, medicine, essentials</p>
          </div>
        </div>

        {/* Popular Services */}
        <div className="mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8">Popular Services</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* AC Repair */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">❄️</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-cyan-400 text-lg sm:text-xl font-bold mb-3">AC Repair & Service</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Professional AC repair, installation, and maintenance services</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.8 (2.3k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹299</span>
                </div>
                <button className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>

            {/* Plumbing */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">🔧</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-green-400 text-lg sm:text-xl font-bold mb-3">Plumbing Services</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Expert plumbing repairs, installations, and emergency services</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.7 (1.8k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹199</span>
                </div>
                <button className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>

            {/* Electrical */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-yellow-500 to-orange-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">⚡</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-yellow-400 text-lg sm:text-xl font-bold mb-3">Electrical Services</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Licensed electricians for wiring, repairs, and installations</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.9 (3.1k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹249</span>
                </div>
                <button className="w-full bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>

            {/* Cleaning */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">🧹</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-purple-400 text-lg sm:text-xl font-bold mb-3">Home Cleaning</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Deep cleaning, regular maintenance, and specialized cleaning</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.6 (2.7k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹399</span>
                </div>
                <button className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>

            {/* Car Wash */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">🚗</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-blue-400 text-lg sm:text-xl font-bold mb-3">Car Wash & Detailing</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Professional car washing, detailing, and interior cleaning</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.8 (1.9k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹299</span>
                </div>
                <button className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>

            {/* Pest Control */}
            <div className="group backdrop-blur-lg bg-white/10 rounded-3xl overflow-hidden shadow-2xl hover:bg-white/15 transition-all duration-500 hover:scale-105 border border-white/20">
              <div className="h-40 sm:h-48 bg-gradient-to-br from-red-500 to-pink-600 flex items-center justify-center">
                <div className="text-5xl sm:text-6xl">🐛</div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-red-400 text-lg sm:text-xl font-bold mb-3">Pest Control</h3>
                <p className="text-gray-300 mb-4 text-sm sm:text-base">Effective pest control services for homes and offices</p>
                <div className="flex justify-between items-center mb-4">
                  <span className="text-green-400 font-semibold text-sm">⭐ 4.7 (1.4k reviews)</span>
                  <span className="text-white font-bold text-sm sm:text-base">From ₹499</span>
                </div>
                <button className="w-full bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                  Book Now
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Emergency Services */}
        <div className="backdrop-blur-lg bg-gradient-to-r from-red-500/20 to-orange-500/20 rounded-3xl p-6 sm:p-8 mb-12 sm:mb-16 border border-red-500/30">
          <div className="text-center mb-6 sm:mb-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">🚨 Emergency Services</h2>
            <p className="text-gray-300 text-base sm:text-lg">24/7 emergency services available in your area</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl mb-3">🚑</div>
              <h3 className="text-red-400 font-bold text-base sm:text-lg mb-2">Medical Emergency</h3>
              <p className="text-gray-300 text-sm mb-4">Ambulance and medical assistance</p>
              <button className="bg-red-600 hover:bg-red-700 px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                Call Emergency
              </button>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl mb-3">🔥</div>
              <h3 className="text-orange-400 font-bold text-base sm:text-lg mb-2">Fire Emergency</h3>
              <p className="text-gray-300 text-sm mb-4">Fire fighting and rescue services</p>
              <button className="bg-orange-600 hover:bg-orange-700 px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                Call Fire Dept
              </button>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl mb-3">🚔</div>
              <h3 className="text-blue-400 font-bold text-base sm:text-lg mb-2">Police Emergency</h3>
              <p className="text-gray-300 text-sm mb-4">Law enforcement and security</p>
              <button className="bg-blue-600 hover:bg-blue-700 px-4 sm:px-6 py-2 sm:py-3 rounded-xl font-semibold transition-all duration-300 text-sm sm:text-base">
                Call Police
              </button>
            </div>
          </div>
        </div>

        {/* How It Works */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">How Fixet Works</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
            <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-4 sm:p-6 border border-white/20">
              <div className="text-4xl sm:text-5xl mb-4">📱</div>
              <h3 className="text-cyan-400 font-bold text-lg sm:text-xl mb-3">1. Book Service</h3>
              <p className="text-gray-300 text-sm sm:text-base">Choose your service, select time slot, and confirm booking</p>
            </div>
            <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-4 sm:p-6 border border-white/20">
              <div className="text-4xl sm:text-5xl mb-4">👨‍🔧</div>
              <h3 className="text-green-400 font-bold text-lg sm:text-xl mb-3">2. Professional Arrives</h3>
              <p className="text-gray-300 text-sm sm:text-base">Verified professional reaches your location on time</p>
            </div>
            <div className="backdrop-blur-lg bg-white/10 rounded-3xl p-4 sm:p-6 border border-white/20">
              <div className="text-4xl sm:text-5xl mb-4">✅</div>
              <h3 className="text-purple-400 font-bold text-lg sm:text-xl mb-3">3. Service Complete</h3>
              <p className="text-gray-300 text-sm sm:text-base">Quality service delivered, payment processed securely</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="backdrop-blur-lg bg-white/5 border-t border-white/10 mt-16">
          <div className="max-w-6xl mx-auto p-6 sm:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
              {/* Company Info */}
              <div>
                <h3 className="text-cyan-400 font-bold text-lg mb-4">Fixet</h3>
                <p className="text-gray-300 text-sm mb-4">
                  Your trusted partner for all urban services. From home repairs to daily essentials,
                  we connect you with verified professionals.
                </p>
                <div className="flex space-x-4">
                  <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                    📘
                  </div>
                  <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                    📷
                  </div>
                  <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                    🐦
                  </div>
                  <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer">
                    💼
                  </div>
                </div>
              </div>

              {/* Services */}
              <div>
                <h4 className="text-white font-semibold mb-4">Services</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Home Cleaning</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">AC Repair</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Plumbing</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Electrical</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Pest Control</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Car Services</a></li>
                </ul>
              </div>

              {/* Company */}
              <div>
                <h4 className="text-white font-semibold mb-4">Company</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">About Us</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Careers</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Press</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Blog</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Contact</a></li>
                </ul>
              </div>

              {/* Support */}
              <div>
                <h4 className="text-white font-semibold mb-4">Support</h4>
                <ul className="space-y-2 text-sm text-gray-300">
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Help Center</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Safety</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Terms of Service</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Privacy Policy</a></li>
                  <li><a href="#" className="hover:text-cyan-400 transition-colors">Cookie Policy</a></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="border-t border-white/10 pt-8">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
                <div className="flex items-center">
                  <div className="text-cyan-400 mr-3">📧</div>
                  <div>
                    <div className="text-white font-medium text-sm">Email</div>
                    <div className="text-gray-300 text-sm">support@fixet.com</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-cyan-400 mr-3">📱</div>
                  <div>
                    <div className="text-white font-medium text-sm">Phone</div>
                    <div className="text-gray-300 text-sm">+91-XXXXXXXXXX</div>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-cyan-400 mr-3">🏢</div>
                  <div>
                    <div className="text-white font-medium text-sm">Address</div>
                    <div className="text-gray-300 text-sm">New Delhi, India</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center">
              <div className="text-gray-400 text-sm mb-4 sm:mb-0">
                © 2025 Fixet Technologies Pvt Ltd. All rights reserved.
              </div>
              <div className="flex space-x-6 text-sm text-gray-400">
                <a href="#" className="hover:text-cyan-400 transition-colors">Privacy</a>
                <a href="#" className="hover:text-cyan-400 transition-colors">Terms</a>
                <a href="#" className="hover:text-cyan-400 transition-colors">Cookies</a>
                <a href="#" className="hover:text-cyan-400 transition-colors">Sitemap</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  )
}
